<template>
   <header class="site-header">
      <div class="header-inner">
         <router-link class="brand-link" to="/" aria-label="Elkhorn Valley Family Medicine home">
            <img class="header-logo" src="@/assets/home/EVFM-logo.png" alt="Elkhorn Valley Family Medicine" width="570" height="120">
         </router-link>
         <div class="header-contact">
            <router-link class="visit-link" :to="{ path: '/', hash: '#visit-information' }">Hours &amp; directions</router-link>
            <a class="schedule-link" href="tel:+14023364222">
               <i class="pi pi-phone" aria-hidden="true"></i>
               <span>Call to schedule <span class="header-phone">(402) 336-4222</span></span>
            </a>
         </div>
      </div>
      <div class="navigation-wrap">
         <nav ref="navigation" class="header-navigation" aria-label="Main navigation"
            @keydown.esc.prevent.stop="closeWithEscape" @focusout="onFocusOut">
            <button ref="menuToggle" class="menu-toggle" type="button"
               aria-controls="main-navigation-links" :aria-expanded="menuOpen" @click="menuOpen = !menuOpen">
               <i class="pi pi-bars" aria-hidden="true"></i>
               {{ menuOpen ? 'Close menu' : 'Menu' }}
            </button>
            <ul id="main-navigation-links" class="navigation-links" :class="{ 'is-open': menuOpen }">
               <li v-for="item in items" :key="item.label">
                  <details v-if="item.items" @toggle="onSectionToggle">
                     <summary>{{ item.label }}</summary>
                     <ul class="navigation-submenu">
                        <li v-for="child in item.items" :key="child.to">
                           <router-link :to="child.to" @click="closeMenu">{{ child.label }}</router-link>
                        </li>
                     </ul>
                  </details>
                  <router-link v-else :to="item.to" @click="closeMenu">{{ item.label }}</router-link>
               </li>
            </ul>
         </nav>
      </div>
   </header>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
        return {
            menuOpen: false,
            items: [
                {
                   label: 'Home',
                   to: '/'
                },
                {
                   label: 'Providers',
                   items:[
                      {
                         label: 'Peter Lueninghoener MD',
                         to: '/providers/peter-lueninghoener'
                      },
                      {
                         label: 'Heather Pardun APRN',
                         to: '/providers/heather-pardun'
                      },
                      {
                         label: 'Jenna Kaup APRN',
                         to: '/providers/jenna-kaup'
                      }
                   ]
                },
                {
                   label: 'Telemedicine',
                   to: '/telemedicine'
                },
                {
                   label: 'Chiropractic',
                   items:[
                      {
                         label: 'Guy Fenske DC',
                         to: '/providers/guy-fenske'
                      }
                   ]
                },
                {
                   label: 'Clinical Services',
                   to: '/services'
                },
                {
                   label: 'Office Staff',
                   to: '/office-staff'
                },
                {
                   label: 'Patient Forms',
                   to: '/patient-forms'
                }
             ]
        }
    },
    watch: {
       '$route.fullPath'() {
          this.closeMenu();
       }
    },
    methods: {
       closeMenu(event) {
          const currentPage = event && event.currentTarget.getAttribute('aria-current') === 'page';
          this.menuOpen = false;
          this.$refs.navigation.querySelectorAll('details[open]').forEach(section => {
             section.open = false;
          });
          if (currentPage) {
             this.$nextTick(() => {
                const heading = document.querySelector('#main-content h1');
                heading.setAttribute('tabindex', '-1');
                heading.focus({ preventScroll: true });
             });
          }
       },
       closeWithEscape(event) {
          const section = event.target.closest('details[open]')
             || this.$refs.navigation.querySelector('details[open]');
          if (section) {
             section.open = false;
             section.querySelector('summary').focus();
          } else if (this.$refs.menuToggle.getClientRects().length) {
             this.closeMenu();
             this.$refs.menuToggle.focus();
          }
       },
       onFocusOut(event) {
          if (!this.$refs.navigation.contains(event.relatedTarget)) this.closeMenu();
       },
       onSectionToggle(event) {
          if (event.target.open) {
             this.$refs.navigation.querySelectorAll('details[open]').forEach(section => {
                if (section !== event.target) section.open = false;
             });
          }
       }
    }
}
</script>

<style scoped>
.site-header {
   background: #fff;
   border-bottom: 1px solid #e3dcd6;
}
.header-inner {
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: space-between;
   gap: 1.5rem;
   width: min(100% - 2.5rem, 72rem);
   margin: 0 auto;
   padding: 1.25rem 0;
}
.brand-link {
   display: block;
   min-width: 0;
   max-width: 23rem;
}
.header-logo {
   display: block;
   width: 100%;
   height: auto;
}
.header-contact {
   display: flex;
   align-items: center;
   gap: 1.5rem;
   flex-shrink: 0;
   max-width: 100%;
   flex-wrap: wrap;
}
.visit-link {
   display: inline-flex;
   align-items: center;
   min-height: 44px;
   color: #7f2532;
   font-size: .95rem;
   text-underline-offset: .2em;
}
.schedule-link {
   display: flex;
   align-items: center;
   justify-content: center;
   gap: .75rem;
   min-height: 48px;
   padding: .65rem 1rem;
   background: #7f2532;
   border-radius: .35rem;
   color: #fff;
   font-weight: 700;
   text-decoration: none;
   text-align: left;
   max-width: 100%;
   overflow-wrap: anywhere;
}
.schedule-link:hover {
   background: #601c26;
}
.header-phone {
   display: block;
   margin-top: .2rem;
   font-size: .85rem;
   font-weight: 400;
}
.site-header a:focus-visible {
   outline: 3px solid #234c35;
   outline-offset: 4px;
}
.navigation-wrap {
   border-top: 1px solid #f0ebe7;
   background: #faf7f3;
}
.header-navigation {
   width: min(100% - 2.5rem, 72rem);
   margin: 0 auto;
   padding: .25rem 0;
}
.navigation-links, .navigation-submenu {
   margin: 0;
   padding: 0;
   list-style: none;
}
.navigation-links {
   display: flex;
   flex-wrap: wrap;
}
.navigation-links > li {
   min-width: 0;
}
.navigation-links a, summary, .menu-toggle {
   display: flex;
   align-items: center;
   gap: .6rem;
   min-height: 48px;
   padding: .65rem .8rem;
   color: var(--green);
   font: inherit;
   line-height: 1.5;
   text-decoration: none;
   overflow-wrap: anywhere;
   cursor: pointer;
}
summary {
   display: list-item;
   list-style-position: inside;
}
.navigation-links a:hover, summary:hover {
   background: #edf2eb;
}
.navigation-links a[aria-current="page"] {
   color: var(--burgundy);
   text-decoration: underline;
}
details {
   position: relative;
}
.navigation-submenu {
   position: absolute;
   z-index: 20;
   width: 20rem;
   max-width: calc(100vw - 2.5rem);
   background: #fff;
   border: 1px solid var(--border);
   border-radius: .35rem;
   box-shadow: 0 4px 12px #2c3e5014;
}
.menu-toggle {
   display: none;
   border: 1px solid var(--border);
   border-radius: .35rem;
   background: #fff;
}
summary:focus-visible, .menu-toggle:focus-visible {
   outline: 3px solid var(--green);
   outline-offset: 2px;
}
@media screen and (max-width: 64rem) {
   .menu-toggle {
      display: flex;
   }
   .navigation-links {
      display: none;
   }
   .navigation-links.is-open {
      display: block;
      padding-top: .5rem;
   }
   .navigation-submenu {
      position: static;
      width: auto;
      max-width: none;
      margin-left: .75rem;
      box-shadow: none;
   }
}
@media screen and (max-width: 44rem) {
   .header-inner {
      flex-wrap: wrap;
      justify-content: center;
      gap: 1rem;
      padding: 1rem 0;
   }
   .brand-link {
      width: min(100%, 20rem);
   }
   .header-contact {
      flex-wrap: wrap;
      justify-content: center;
      gap: .75rem 1.25rem;
      width: 100%;
   }
   .schedule-link {
      font-size: .9rem;
   }
}
</style>